import { MAX_IMAGE_SIZE_BYTES } from '../constants';

/**
 * Validates if an image is suitable for AI alt text generation based on size and type.
 */
export const validateImageForAIGeneration = (
  imageSize: number,
  imageType: string | null,
  maxSizeBytes: number = MAX_IMAGE_SIZE_BYTES,
): {
  isValid: boolean;
  reason?: string;
} => {
  if (!imageType) {
    return {
      isValid: false,
      reason: 'Unknown image type',
    };
  }

  const isSupportedType = isSupportedImageType(imageType);
  const isSizeOverLimit = imageSize >= maxSizeBytes;

  if (isSizeOverLimit && !isSupportedType) {
    return {
      isValid: false,
      reason: `${imageType.toUpperCase()} images must be under ${maxSizeBytes / (1024 * 1024)} MB for auto-generation`,
    };
  }

  return {
    isValid: true,
  };
};

/**
 * Checks if an image type is supported for resizing operations.
 */
export const isSupportedImageType = (imageType: string | null): boolean => {
  if (!imageType) return false;
  return [
    'png',
    'jpg',
    'jpeg',
  ].includes(imageType.toLowerCase());
};

/**
 * Determines if AI generation should be disabled based on image properties.
 */
export const shouldDisableAIGeneration = (
  imageSize?: number,
  imageType?: string | null,
  maxSizeBytes: number = MAX_IMAGE_SIZE_BYTES,
): boolean => {
  if (!imageSize || !imageType) return false;

  const validation = validateImageForAIGeneration(imageSize, imageType, maxSizeBytes);
  return !validation.isValid;
};
